module.exports = __webpack_public_path__ + "static/media/10.7c1155a6.JPG";